export default __webpack_public_path__ + "static/media/warning.230435aa.svg";